import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../utils/errorHandler";
import { toast } from "react-toastify";
import  prod  from '../../../api/prod.json'

export default function* watcherAddUserSaga() {
  yield takeEvery("ADD_USER", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "SUBMIT_LOADING_BUTTON_SPINNERS", payload: true });
    let payload = {};
    var formatUrl = `api/users/1`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    const doc_ = prod.find(x=>x.companyId == localStorage.getItem("#companyId"));
    const total_users_count= doc_.users;
    console.log(payload.items)
    const active_users_count = payload.items?.filter(x=>x.active == 1)?.length;
  
    if(active_users_count > total_users_count ){
      alert(`Your current users is ${active_users_count} and your limit is ${total_users_count}`);
      return;
    }
    console.log(payload.items)

    yield request("post", action.payload, "api/user/create-user").then(
      (response) => {
        payload = response;
      }
    );
    toast.success("User Added Successfully");
    var formatUrl = `api/users/1`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    console.log(payload.items)
    yield put({ type: "USER_LISTS", payload: payload.items });
    yield put({ type: "USER_LIST1", payload: payload.items });
    yield put({ type: "CURRENT_PAGE", payload: payload.currentPage });
    yield put({ type: "TOTAL_PAGES", payload: payload.totalPages });
    yield put({ type: "TOTAL_ITEMS", payload: payload.totalItems });
    var formatUrl = `api/userType`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "USER_TYPE_LIST", payload: payload });
    var formatUrl = `api/position`;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "POSITION_LIST", payload: payload });
    yield put({ type: "SUBMIT_LOADING_BUTTON_SPINNERS", payload: false });
  } catch (e) {
    yield put({ type: "SUBMIT_LOADING_BUTTON_SPINNERS", payload: false });
    console.log("add-user-saga", e.response);
    console.log(e.response);
    console.log(e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: false });
  }
}
